export default __webpack_public_path__ + "static/media/total-revenues.8cddc289.svg";